import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "logo logo-dark"
}
const _hoisted_2 = {
  key: 1,
  class: "logo logo-light"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_4 = { class: "box-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "dots-top",
  src: "/kandidaten/img/dot-pattern-square.svg"
}
const _hoisted_6 = {
  key: 1,
  class: "dots-bottom",
  src: "/kandidaten/img/dot-pattern-square.svg"
}
const _hoisted_7 = { class: "login" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M27.391 14.949C27.3149 14.9496 27.2415 14.9213 27.1855 14.87L26.6712 14.3556L24.1106 11.795V15.4163V27.2711C24.1106 27.3507 24.079 27.427 24.0227 27.4832C23.9664 27.5395 23.8901 27.5711 23.8106 27.5711H20.2106C20.131 27.5711 20.0547 27.5395 19.9984 27.4832L18.9378 28.5439L19.9984 27.4832C19.9422 27.427 19.9106 27.3507 19.9106 27.2711V23.6711C19.9106 22.7959 19.5629 21.9565 18.944 21.3377L17.8834 22.3983L18.944 21.3376C18.3251 20.7188 17.4858 20.3711 16.6106 20.3711H13.0106C12.1353 20.3711 11.296 20.7188 10.6771 21.3376C10.0582 21.9565 9.71056 22.7959 9.71056 23.6711V27.2711C9.71056 27.3507 9.67895 27.427 9.62269 27.4832C9.56643 27.5395 9.49013 27.5711 9.41056 27.5711H5.81056C5.73099 27.5711 5.65469 27.5395 5.59843 27.4832C5.54217 27.427 5.51056 27.3507 5.51056 27.2711V15.4163V11.795L2.9499 14.3556L2.43558 14.87C2.37964 14.9213 2.3062 14.9496 2.23008 14.949C2.15141 14.9483 2.07617 14.9167 2.02055 14.8611C1.96492 14.8055 1.93337 14.7302 1.93269 14.6516C1.93203 14.5755 1.96034 14.502 2.01171 14.4461L14.5985 1.85932C14.5985 1.85927 14.5986 1.85921 14.5986 1.85916C14.6549 1.80302 14.7311 1.77148 14.8106 1.77148C14.89 1.77148 14.9663 1.80302 15.0225 1.85916C15.0226 1.85921 15.0226 1.85927 15.0227 1.85932L27.6094 14.4461C27.6608 14.502 27.6891 14.5755 27.6884 14.6516C27.6877 14.7302 27.6562 14.8055 27.6006 14.8611C27.545 14.9167 27.4697 14.9483 27.391 14.949Z",
      fill: "#2563EB",
      stroke: "#2563EB",
      "stroke-width": "3"
    })
  ])
], -1)
const _hoisted_9 = { class: "login-register-switch" }
const _hoisted_10 = { class: "active" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { for: "username" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = { for: "password" }
const _hoisted_15 = {
  key: 0,
  class: "error-message"
}
const _hoisted_16 = { class: "recover-password" }
const _hoisted_17 = { class: "mobile-bottom-nav" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "p-float-label" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Email", -1)

import {ref, getCurrentInstance, onMounted} from "vue";
import {useI18n} from "vue-i18n";
import {createAuthenticationService} from '@/services/authenticationService';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ['closed', 'set-bookmark', 'register', 'logged-in'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const app = getCurrentInstance();
const display = ref(false);
const user = ref();
const password = ref();
const close = function () {
    display.value = false;
    emit("closed");
}
const show = function (options) {
    loginOptions.value = options;
    display.value = true;
}
const showWithEmail = function (email, options) {
    user.value = email;
    loginOptions.value = options;
    display.value = true;
    }

const isLoggedIn = ref(false);
const loginFailed = ref(false);
const {t} = useI18n();

const displayRecoverPasswordDialog = ref(false);
const passwordEmailSent = ref(false);
const loginOptions = ref(null);

const checkLogin = async () => {
    isLoggedIn.value = app?.appContext.config.globalProperties.$auth.isAuthenticated.value ?? false;
}

onMounted(async () => {
    await checkLogin();
    setTimeout(() => {
        if (user.value)
            user.value = '' + user.value;
        if (password.value)
            password.value = '' + password.value;
    }, 200);
});

    const login = async () => {
    loginFailed.value = false;

    const authenticationService = createAuthenticationService(app);
    const result = await authenticationService.loginWithPassword(user.value, password.value);
    password.value = '';

    if (!result) {
        loginFailed.value = true;
        return;
    }

    user.value = '';

    if (!sessionStorage.getItem("login_t")) {
        sessionStorage.setItem("login_t", "true");
    }

    emit("logged-in");
    display.value = false;
}

const signup = () => {

    close();
    if (loginOptions.value?.register) {
        loginOptions.value?.register();
    } else
        emit('register', user.value);
}

const recoverPassword = async () => {
    const authenticationService = createAuthenticationService(app);
    await authenticationService.recoverPassword(user.value);
    passwordEmailSent.value = true;
};

__expose({
    show,
    login,
    signup,
    recoverPassword,
    displayRecoverPasswordDialog,
    showWithEmail,
    close
});



return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: display.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((display).value = $event)),
      modal: true,
      class: _normalizeClass(['login-dialog', {'tech':loginOptions.value?.isTech}]),
      baseZIndex: 107,
      closable: false
    }, {
      default: _withCtx(() => [
        (loginOptions.value?.isTech)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : (_openBlock(), _createElementBlock("div", _hoisted_2)),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.showSpinner)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          (!_ctx.showSpinner)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("h1", null, _toDisplayString(_unref(t)("login.headline1")), 1),
            _createElementVNode("h2", null, _toDisplayString(_unref(t)("login.headline2")), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (signup())),
                "data-cy": "wizard-registration-btn"
              }, _toDisplayString(_unref(t)("register")), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("login")), 1)
            ]),
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_InputText, {
                id: "username",
                type: "email",
                modelValue: user.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user).value = $event)),
                "data-cy": "username",
                class: _normalizeClass({ 'p-invalid': !user.value})
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)("your.mail.address")), 1)
            ]),
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_Password, {
                id: "password",
                modelValue: password.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                feedback: false,
                "data-cy": "password",
                class: _normalizeClass({ 'p-invalid': !password.value}),
                onKeyup: _withKeys(login, ["enter"])
              }, null, 8, ["modelValue", "class"]),
              _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)("your.password")), 1)
            ]),
            (loginFailed.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)("login.failed")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (displayRecoverPasswordDialog.value = true))
              }, _toDisplayString(_unref(t)("login.recoverpassword")), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Button, {
                class: "login-button button-primary button-rectangle big stretch",
                label: _unref(t)('login.now'),
                onClick: login,
                "data-cy": "login"
              }, null, 8, ["label"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "class"]),
    _createVNode(_component_Dialog, {
      visible: displayRecoverPasswordDialog.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((displayRecoverPasswordDialog).value = $event)),
      header: _unref(t)('recover.password'),
      baseZIndex: 108,
      style: {width: '500px'}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _unref(t)('close'),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (displayRecoverPasswordDialog.value = false)),
          class: "button-primary"
        }, null, 8, ["label"]),
        (passwordEmailSent.value)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _unref(t)('send.mail.again'),
              onClick: recoverPassword,
              class: "button-primary"
            }, null, 8, ["label"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: _unref(t)('send.mail'),
              onClick: recoverPassword,
              class: "button-primary"
            }, null, 8, ["label"]))
      ]),
      default: _withCtx(() => [
        (passwordEmailSent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)("login.password.recovery1")), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)("login.password.recovery2")), 1),
              _hoisted_20
            ])),
        _createElementVNode("span", _hoisted_21, [
          _createVNode(_component_InputText, {
            id: "username",
            type: "email",
            modelValue: user.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user).value = $event)),
            "data-cy": "username",
            autofocus: ""
          }, null, 8, ["modelValue"]),
          _hoisted_22
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})